import { IconProps } from 'src/utils/icon';

const OpenArrowRightIcon: React.FC<IconProps> = ({
  size = 1,
  fill = 'var(--white)',
}) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 7 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 0.5L4.5 4.5L0.5 8.5"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default OpenArrowRightIcon;
